class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.predictiveSearchForm = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search-results');

        this.searchDropdownContainer = this.querySelector('.search-dropdown-container');
        this.recommendationProducts = this.querySelector('.search-dropdown-recommendations');

        this.tabList = this.querySelector('.psr_tab_list'); 
        this.tabContents = this.querySelectorAll('.psr_tab_content'); 

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
        
        if (this.tabList) {
            this.tabList.addEventListener('click', this.handleTabClick.bind(this));
        }
    }

    onChange() {
        const searchTerm = this.input.value.trim();
        
        if (!searchTerm.length) {
            this.close();
            return;
        }
        let searchTerms = {};
        const formElements = Array.from(this.predictiveSearchForm);
        formElements.forEach(element => {
            if (element.name.length) {
                searchTerms[element.name] = element.value;
            }
        });
        const stringifySearchTerms = JSON.stringify(searchTerms);
        const paramsSearchTerms = stringifySearchTerms.slice(1, -1).replace(/","/g, '"&"').replace(/:/g, '=').replace(/"/g, '');
        this.getSearchResults(paramsSearchTerms);
    }

    getSearchResults(searchTerms) {
        fetch(`${window.Shopify.routes.root}search/suggest?${searchTerms}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }
                return response.text();
            })
            .then((res) => {
                const resultsMarkup = new DOMParser().parseFromString(res, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                if (window.jdgm && window.jdgm.customizeBadges) {
                    window.jdgm.customizeBadges();
                }
                this.tabList = this.querySelector('.psr_tab_list');
                this.tabContents = this.querySelectorAll('.psr_tab_content');

                if (this.tabList) {
                    this.tabList.removeEventListener('click', this.handleTabClick.bind(this));
                    this.tabList.addEventListener('click', this.handleTabClick.bind(this));
                }

                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    handleTabClick(event) {
        const targetButton = event.target.closest('button[role="tab"]');
        if (!targetButton) return;

        this.tabList.querySelectorAll('button[role="tab"]').forEach(button => {
            button.setAttribute('aria-selected', 'false');
        });

        this.tabContents.forEach(content => {
            content.classList.add('hidden');
        });

        targetButton.setAttribute('aria-selected', 'true');

        const contentId = targetButton.getAttribute('aria-controls');
        const activeContent = this.querySelector(`#${contentId}`);

        if (activeContent) {
            activeContent.classList.remove('hidden');
        }
    }

    open() {
        this.searchDropdownContainer.classList.add('has-predictive-search-results');
        if(this.recommendationProducts){
            this.recommendationProducts.classList.add('inactive');
        }
    }

    close() {
        this.searchDropdownContainer.classList.remove('has-predictive-search-results');

        if(this.recommendationProducts){
            this.recommendationProducts.classList.remove('inactive');
        }
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}
customElements.define('predictive-search', PredictiveSearch);